export function instrumentObject<T>(obj: T, name: string): T {
  return Object.assign(obj as any, { _debugName: name });
}
